import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import config from '@/config';

class Auth {
  userManager: UserManager;
  private _user?: User | null;

  constructor () {
    const { protocol, hostname, port } = window.location;
    const settings: UserManagerSettings = {
      authority: config.okta.issuer,
      /* eslint-disable @typescript-eslint/camelcase */
      client_id: config.okta.clientId,
      redirect_uri: `${protocol}//${hostname}${port ? `:${port}` : ''}/callback`,
      silent_redirect_uri: `${protocol}//${hostname}${port ? `:${port}` : ''}/silent_renew.html`,
      post_logout_redirect_uri: `${protocol}//${hostname}${port ? `:${port}` : ''}/`,
      automaticSilentRenew: true,
      response_type: 'id_token token',
      scope: 'openid profile email',
      userStore: new WebStorageStateStore({ store: window.localStorage })
    };
    /* eslint-enable @typescript-eslint/camelcase */

    this.userManager = new UserManager(settings);
    this.userManager.events.addUserLoaded((user) => {
      this._user = user;
      window.localStorage.setItem('user', JSON.stringify(user));
    });
  }

  async signIn (redirect?: string) {
    window.sessionStorage.setItem('redirectTo', redirect || '/');
    await this.userManager.signinRedirect();
  }

  async signInRedirect () {
    try {
      this._user = await this.userManager.signinRedirectCallback();
      window.localStorage.setItem('user', JSON.stringify(this._user));
      return window.sessionStorage.getItem('redirectTo') || '/';
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async logout () {
    let redirect = true;
    if (this._user) {
      redirect = false;
      await this.userManager.signoutRedirect();
      window.localStorage.removeItem('user');
      this._user = undefined;
    }
    window.localStorage.clear();
    return redirect;
  }

  async check () {
    const user = await this.userManager.getUser();
    const isTokenExpired = !user || new Date(user.expires_at * 1000).getTime() < new Date().getTime();
    this._user = isTokenExpired ? null : user;
    return !!this._user;
  }

  async getUser () {
    await this.check();
    // Update local storage
    window.localStorage.setItem('user', JSON.stringify(this._user));

    return this._user;
  }

  canEdit () {
    // TODO I don't like that we are relying on the user from local storage
    // we would need to make it async though, which would make it harder to use in components
    // unless you can now have async computed or use a method instead
    const userString = window.localStorage.getItem('user');
    if (userString) {
      const storedUser: User | null = JSON.parse(userString);
      if (storedUser) {
        const emails = [
          'friedk@ou.org',
          'cutlerd@ou.org',
          'cutlerd@ncsy.org',
          'friedk@ncsy.org'
        ];
        if (emails.find(e => e === storedUser.profile.email || '')) {
          return false;
        }
      }

      return true;
    }
    // Is this correct? maybe they are not signed in?
    return true;
  }

  getHeaders (headers = {}) {
    if (this._user && this._user.access_token) {
      const authHeader = {
        Authorization: `Bearer ${this._user.access_token}`
      };
      return Object.assign(headers, authHeader);
    }
    return headers;
  }
}

export default new Auth();
